import {useEffect, useState} from 'react';

import {getDeviceType, isBrowser} from '@/shared/lib/env';

export const useDeviceType = (onlyClientRender = false) => {
  const [deviceType, setDeviceType] = useState<
    ReturnType<typeof getDeviceType>
  >(onlyClientRender && isBrowser() ? getDeviceType() : 'Unknown');

  useEffect(() => {
    setDeviceType(getDeviceType());
  }, []);

  return deviceType;
};
